import React from "react";
import { useSelector } from "react-redux";

const AuthFour = () => {
  const locale = useSelector((state) => state.theme.locale);
  return (
    <div
      className="flex-1 flex flex-col items-center justify-center bg-no-repeat bg-cover text-center p-5 "
      style={{ backgroundImage: `url('/img/auth/4.jpg')` }}
    >
      {locale === "en" ? (
        <p className="mb-10 text-[32px] text-white leading-snug max-w-[632px]">
          Mol-e provides the most suitable solutions to efficiently and
          sustainably manage your waste, helping you save time and costs.
          <br /> <br />
          Join Mol-e now, protect the environment, optimize your waste
          management, and contribute to the future.
        </p>
      ) : (
        <p className="mb-10 text-[32px] text-white leading-snug max-w-[632px]">
          Mol-e, atıklarınızı verimli ve sürdürülebilir bir şekilde yönetmek
          için size en uygun çözümleri sunarak zaman ve maliyet tasarrufu
          sağlar.
          <br /> <br />
          Şimdi Mol-e’ye katılın, çevreyi koruyun, atık yönetiminizi optimize
          edin ve geleceğe katkıda bulunun.
        </p>
      )}

      <div className="flex items-center justify-between max-w-[632px] w-full gap-10 mt-10">
        <img alt="Waste" src="/img/auth/waste.png" />
        <img alt="Cert" src="/img/auth/cert.png" />
      </div>
    </div>
  );
};

export default AuthFour;
